import { useEffect, useState } from "react";

export function useDeferredLoading(isLoading: boolean, delay: number = 200): boolean {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (isLoading) {
      const timer = setTimeout(() => {
        setShowLoading(true);
      }, delay);

      return () => {
        clearTimeout(timer);
      };
    }

    setShowLoading(false);
  }, [isLoading, delay]);

  return showLoading;
}
